module.exports = __webpack_public_path__ + "static/media/apiStruct2.08669dc4.png";